import { render, staticRenderFns } from "./Cell-Content.vue?vue&type=template&id=88018722&lang=pug"
import script from "./Cell-Content.vue?vue&type=script&lang=js"
export * from "./Cell-Content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports